import React, { useState, useEffect } from 'react';
import { withTranslation } from './ChildrenContext.js';
import PropTypes from 'prop-types';
import FormGroup from './FormGroup';

const ExchangeRates = ({ 
    data = {}, 
    formGroupLabelClass = 'col-xs-12', 
    formGroupFieldClass = 'col-xs-12',
    t = {}
}) => {
    const [stateData, setStateData] = useState(data);
    
    const staticNames = t.exchangeRates || {};
    const staticNameLabels = t.dataTable?.headers || {};

    useEffect(() => {
        setStateData(data);
    }, [data]);

    const keys = Object.keys(stateData);

    if (!keys.length) return null;

    return (
        <div className="ibox">
            <div className="ibox-title">
                <h5>{staticNames.title}</h5>
            </div>
            <div className="ibox-content">
                <div className="form-horizontal form-horizontal_flex">
                    {keys.map((key) => (
                        <FormGroup
                            key={key}
                            label={`${staticNameLabels[key] || key}:`}
                            labelClass={formGroupLabelClass}
                            fieldClass={formGroupFieldClass}
                        >{stateData[key]}</FormGroup>
                    ))}
                </div>
            </div>
        </div>
    );
};

ExchangeRates.propTypes = {
    data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    formGroupLabelClass: PropTypes.string,
    formGroupFieldClass: PropTypes.string,
    t: PropTypes.object
};

export default withTranslation(ExchangeRates);